import React, { SVGProps } from 'react'
const SvgMerchantPending = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <g fill={props.fill || 'var(--color-cta)'} fillRule="nonzero">
      <path d="M4 1.691a1.5 1.5 0 0 0-1.5 1.5v16.934a1.5 1.5 0 0 0 1.5 1.5h11a.5.5 0 0 0 .5-.5V4.95a1.5 1.5 0 0 0-1.24-1.478l-10-1.758A1.5 1.5 0 0 0 4 1.69Zm0 1a.5.5 0 0 1 .087.008l10 1.758.086.024a.5.5 0 0 1 .327.469v15.675H4a.5.5 0 0 1-.5-.5V3.191a.5.5 0 0 1 .5-.5Z" />
      <path d="M15.1 9.635a.5.5 0 0 0-.6.49v11a.5.5 0 0 0 .5.5h5a1.5 1.5 0 0 0 1.5-1.5v-7.968a1.5 1.5 0 0 0-1.203-1.47L15.1 9.635Zm.4 10.99v-9.889l4.6.93a.5.5 0 0 1 .4.49v7.969l-.008.09a.5.5 0 0 1-.492.41h-4.5ZM7.5 12.5a.5.5 0 0 1 .09.992l-.09.008h-2a.5.5 0 0 1-.09-.992l.09-.008h2ZM7.5 9.5a.5.5 0 0 1 .09.992l-.09.008h-2a.5.5 0 0 1-.09-.992L5.5 9.5h2ZM7.5 6.5a.5.5 0 0 1 .09.992L7.5 7.5h-2a.5.5 0 0 1-.09-.992L5.5 6.5h2ZM12.5 12.5a.5.5 0 0 1 .09.992l-.09.008h-2a.5.5 0 0 1-.09-.992l.09-.008h2ZM12.5 9.5a.5.5 0 0 1 .09.992l-.09.008h-2a.5.5 0 0 1-.09-.992l.09-.008h2ZM12.5 6.5a.5.5 0 0 1 .09.992l-.09.008h-2a.5.5 0 0 1-.09-.992l.09-.008h2Z" />
      <path d="M18.5 17.5a.5.5 0 0 1 .09.992l-.09.008h-1a.5.5 0 0 1-.09-.992l.09-.008h1ZM18.5 14.357a.5.5 0 0 1 .09.992l-.09.008h-1a.5.5 0 0 1-.09-.992l.09-.008h1ZM10 15.625H8a1.5 1.5 0 0 0-1.5 1.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-4a1.5 1.5 0 0 0-1.5-1.5Zm0 1 .09.008a.5.5 0 0 1 .41.492v3.5h-3v-3.5a.5.5 0 0 1 .5-.5h2Z" />
    </g>
  </svg>
)
export default SvgMerchantPending
